<template>
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
       viewBox="0 0 86.4 86.4" xml:space="preserve">
<g id="Background">
</g>
<g id="White_blocks">
</g>
<g id="New_icons">
  <g>
  <polygon class="st2" points="67.48,66.76 19.38,66.76 19.38,42.41 25.32,42.41 27.84,45.38 59.8,45.38 62.77,42.41 67.48,42.41
			" />
  <g>
  <line class="st0" x1="28.56" y1="50.36" x2="28.56" y2="61.86" />
  <line class="st0" x1="35.99" y1="50.36" x2="35.99" y2="61.86" />
  <line class="st0" x1="43.43" y1="50.36" x2="43.43" y2="61.86" />
  <line class="st0" x1="50.86" y1="50.36" x2="50.86" y2="61.86" />
  <line class="st0" x1="58.29" y1="50.36" x2="58.29" y2="61.86" />
		</g>
  <path class="st9" d="M25.32,42.41l17.91-14.28c0.35-0.25,0.83-0.26,1.18-0.01l18.36,14.29" />
  <line class="st6" x1="44.05" y1="27.66" x2="44.05" y2="20.26" />
  <polygon class="st1" points="46.1,19.29 41.9,19.29 39.65,15.74 39.65,12.19 47.94,12.19 47.94,15.74 		" />
	</g>
</g>
</svg>
</template>

<script>
export default {
  name: 'CargoHandlingIcon',
};
</script>

<style type="text/css">
  .st0 {
    fill: none;
    stroke: #FFFFFF;
    stroke-width: 2.4;
    stroke-miterlimit: 10;
  }

  .st1 {
    fill: none;
    stroke: #0000008a;
    stroke-width: 2.4;
    stroke-miterlimit: 10;
  }

  .st2 {
    fill: #0000008a;
    stroke: #0000008a;
    stroke-width: 2.4;
    stroke-miterlimit: 10;
  }

  .st6 {
    fill: none;
    stroke: #0000008a;
    stroke-width: 2.4;
    stroke-linecap: round;
    stroke-miterlimit: 10;
  }

  .st9 {
    fill: none;
    stroke: #0000008a;
    stroke-width: 2.4;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
  }
</style>
